import { styled } from '@mui/system';
import { Button, Paper, Typography } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  paddingBottom: 8,
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    paddingBottom: 8
  },
  '&:empty': {
    display: 'none'
  }
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2)
}));

export const ButtonContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'isFormEnabled'
})(({ theme, isFormEnabled }) => ({
  position: 'sticky',
  bottom: 0,
  backgroundColor: '#EEE',
  zIndex: theme.zIndex.appBar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: isFormEnabled ? 'space-between' : 'end',
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  marginBottom: theme.spacing()
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
